<template>
    <v-container fluid>
        <v-row>
            <v-card
                class="w-100 custom-card pa-4"
                elevation="0"
                >
            <div class="d-flex justify-start align-center flex-row">
                <h2 class="text-left">
                    <span v-if="query != '' && activeCategory == ''">{{ `${$t('library.search_result')} "${query}"` }}</span>
                    <span v-if="activeCategory != '' && query == ''"> {{ `${$t('library.search_result')} "${activeCategory}"` }}</span>
                    <span v-if="activeCategory != '' && query != ''"> {{ `${$t('library.search_result')} "${query}" ${$t('library.in')} "${activeCategory}"` }}</span>
                </h2>
                <v-btn icon fab color="primary" class="ml-auto" @click="$emit('clean-search')"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </div>
            <v-row v-if="!loading && errorMessage">
                <v-col cols="12">
                    <p class="text-center font-size-36">{{ errorMessage }}</p>
                </v-col>
            </v-row>
            <v-row v-if="books.length && !errorMessage">
                <v-col
                    data-cy="book-item-carousel"
                    cols="4"
                    sm="auto"
                    :class="`${classCard} px-0 px-sm-2`"
                    v-for="(item, i) in books"
                    :key="i"
                >
                    <book-card-pop-up
                        @cardPopUp="setCardPopup($event, item.id)"
                        :title="item.title"
                        :rating="item.rating"
                        :description="item.bookAbstract"
                        :imageSource="item.resourceDir"
                        :book_id="item.id"
                        :book="item"
                    />
            
                </v-col>
            </v-row>
            <v-row v-if="loading">
                <v-col cols="2" v-for="(n, $index) in 6" :key="$index">
                    <v-skeleton-loader height="300px" width="100%" type="image" />
                </v-col>
            </v-row>
            </v-card>
        </v-row>
    </v-container>
</template>
<script>
import BookCardPopUpVue from './BookCardPopUp.vue'
export default {
    name: 'BookSearchContent',
    props: {
        books: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        errorMessage: { type: [String, Boolean], default: '' },
        query: { type: String, default: '' },
        activeCategory: { type: String, default: '' },
    },
    components: {
        'book-card-pop-up': BookCardPopUpVue
    },
    data: () => ({
        booksActive: [],
    }),
    computed: {
        classCard() {
            if (this.cardPopUp) {
                return 'pop-up-enabled'
            }
            return 'pop-up-disabled search-result'
        },
    },
    methods: {
        setCardPopup($event, id) {
            this.cardPopUp = false
            if ($event) {
                this.cardPopUp = $event
                this.booksActive = [...this.booksActive, id]
            } else {
                this.booksActive = this.booksActive.filter((i) => i !== id)
            }
        },
        someBooks(id) {
            return this.booksActive.some((i) => i === id)
        },
    },
}
</script>
<style lang="scss">
.search-result{
    .book-content{
        height: inherit;
        max-width: 100%;
    }
}
</style>